module.exports = __webpack_public_path__ + "img/step01_tablet.e50a57fe.png";